/**
 * Created by iamso on 13.12.2019.
 */

const PlayButtonView = cc.Node.extend({
    avoidNode: "PlayButtonView",

    ctor: function (options) {
        this._super();

        this.options = options || {};

        this.isSmall = this.options.isSmall;
        this.styles = this.isSmall && cleverapps.styles.PlayButtonView.small || cleverapps.styles.PlayButtonView;

        this.noLevelNumber = cleverapps.config.regime === "knockout"
            || cleverapps.meta.getSelectedLocation().locationConfig.locationType === "shortmeta"
            || cleverapps.meta.getSelectedLocation().locationConfig.locationType === "hose" && cleverapps.user.isPlayingFakeLevels();

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(this.styles);
        this.setAlignment(this.styles.position);
        this.setCascadeOpacityEnabledRecursively(true);

        cleverapps.aims.registerTarget("play_button", this, {
            controls: ["play_button"],
            flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
            flyingUnderShadow: true,
            withoutDelta: true,
            duration: 1000,
            animate: cleverapps.throttle(2000, this.animatePassLevel.bind(this))
        });

        cleverapps.playButton.on("update", this.update.bind(this), this);
        cleverapps.playButton.on("animatePassLevel", this.animatePassLevel.bind(this), this);
        cleverapps.playButton.on("showForce", this.showForce.bind(this), this);

        this.update();
    },

    update: function () {
        this.styling = this.getStyling();

        this.createButton();

        if (!this.styles.button) {
            cleverapps.UI.applyHover(this);
            cleverapps.UI.onClick(this, () => {
                cleverapps.effects.fire("playbutton.press");
                cleverapps.playButton.onClick();
            });
        }
    },

    showForce: function (f) {
        if (cleverapps.forces.isAvailable(this, Forces.METHA_PLAY_BUTTON)) {
            cleverapps.forces.create(this, Forces.METHA_PLAY_BUTTON);
            cleverapps.forces.onceForceClosed = f;
        } else {
            f();
        }
    },

    animatePassLevel: function () {
        cleverapps.focusManager.showControlsWhileFocused(["play_button"]);

        if (this.passLevelAction) {
            this.stopAction(this.passLevelAction);
        }

        if (!this.isSmall && !this.noLevelNumber) {
            const animation = new cleverapps.Spine(bundles.play_button.jsons.play_button_transition_json);
            this.addChild(animation, 1);
            animation.setPosition(this.button.getPosition());
            animation.runAction(new cc.Sequence(
                new cc.DelayTime(0.6),
                new cc.CallFunc(() => {
                    animation.setAnimation(0, "animation", false);
                    animation.setCompleteListenerRemove();
                })
            ));
        }

        const baseScale = this.getScale();
        this.passLevelAction = this.runAction(new cc.Sequence(
            this.listAnimationActions(baseScale)
        )).setFinalize(() => {
            this.setScale(baseScale);
        });
    },

    listAnimationActions: function (baseScale) {
        if (this.noLevelNumber) {
            return [
                new cc.DelayTime(1.1),
                new cc.CallFunc(this.updateTextAndButton.bind(this))
            ];
        }

        return [
            new cc.DelayTime(1.1),
            new cc.ScaleTo(0.15, baseScale * 1.3),
            new cc.CallFunc(this.updateTextAndButton.bind(this)),
            cleverapps.effects.fireAction("playbutton.play"),
            new cc.CallFunc(() => cleverapps.effects.fire("playbutton.press")),
            new cc.ScaleTo(0.2, baseScale)
        ];
    },

    updateTextAndButton: function () {
        this.styling = this.getStyling();

        this.createButton();
    },

    addFinger: function () {
        FingerView.hintTap(this, {
            delay: 5,
            repeatDelay: 5
        });
    },

    createButton: function () {
        const styles = this.styles;

        if (this.button) {
            this.button.removeFromParent();
        }

        const button = this.button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            click_effect: true,
            text: this.getTextMsg(),
            type: this.styling.type,
            icons: this.getIcons(),
            onClicked: function () {
                cleverapps.effects.fire("playbutton.press");
                cleverapps.playButton.onClick();
            }
        });

        this.addChild(button);
        button.setAlignment(styles.button);
    },

    getTextMsg: function () {
        const level = this.getDisplayedLevel();

        let msg = this.noLevelNumber ? "Play" : "PlayButton.text";
        if (level.isHard() && this.options.hard !== false) {
            msg = level.isSuperHard() ? "message.superHardLevel" : "message.hardLevel";
        }
        if (level.isTricky()) {
            msg = "message.trickyLevel";
        }
        if (level.isBonus()) {
            msg = "message.bonusLevel";
        }

        const levelNo = cleverapps.playButton.getLevelNo();
        let params = { levelNo };

        if (this.getRoyalLeague()) {
            msg = "RoyalLeague.PlayButton.text";
            params = { round: levelNo };
        }

        if (this.isSmall) {
            msg = levelNo;
        } else {
            msg = Messages.get(msg, params);
        }

        if (this.getIcons()) {
            msg = this.isSmall ? `*${msg}` : `* ${msg}`;
        }

        return msg;
    },

    getIcons: function () {
        if (cleverapps.config.name === "woodenblock") {
            return { "*": bundles.play_button.frames.jewel_png };
        }

        const royalLeague = this.getRoyalLeague();
        if (royalLeague) {
            return { "*": royalLeague.logic.getCrownIcon() };
        }
    },

    getRoyalLeague: function () {
        return cleverapps.missionManager.findRunningMission(Mission.TYPE_ROYAL_LEAGUE);
    },

    getDisplayedLevel: function () {
        if (cleverapps.playButton.passedLevel && cleverapps.playButton.previousLevel) {
            return cleverapps.playButton.previousLevel;
        }

        return cleverapps.playButton.currentLevel;
    },

    getStyling: function () {
        const level = this.getDisplayedLevel();
        const styles = this.styles;

        let playButton = {
            button_png: bundles.play_button.frames.play_button_png,
            button_on_png: bundles.play_button.frames.play_button_on_png
        };

        if (this.isSmall) {
            playButton = {
                button_png: bundles.play_button.frames.small_play_button_png || playButton.button_png,
                button_on_png: bundles.play_button.frames.small_play_button_on_png || playButton.button_on_png
            };
        }

        if (styles.button && styles.button.SKIP_RESOLUTION && styles.button.SKIP_RESOLUTION.padding) {
            playButton.SKIP_RESOLUTION = {
                padding: styles.button.SKIP_RESOLUTION.padding
            };
        }

        if (level.isHard()) {
            playButton = Object.assign(playButton, {
                button_png: bundles.play_button.frames.hard_button_png || bundles.buttons.frames.red_button,
                button_on_png: bundles.play_button.frames.hard_button_on_png || bundles.buttons.frames.red_button_on
            });

            if (this.isSmall && bundles.play_button.frames.small_hard_button_png) {
                playButton = Object.assign(playButton, {
                    button_png: bundles.play_button.frames.small_hard_button_png,
                    button_on_png: bundles.play_button.frames.small_hard_button_on_png
                });
            }
        }

        if (level.isSuperHard() && bundles.play_button.frames.super_hard_button_png) {
            playButton = Object.assign(playButton, {
                button_png: bundles.play_button.frames.super_hard_button_png,
                button_on_png: bundles.play_button.frames.super_hard_button_on_png
            });
        }

        if (level.isTricky() || level.isBonus()) {
            playButton = Object.assign(playButton, cleverapps.styles.UI.Button.Images.button_blue);
        }

        return {
            type: playButton
        };
    }
});

if (cleverapps.config.type === "blocks") {
    PlayButtonView.prototype.animatePassLevel = function () {
        if (this.button) {
            this.button.stopAllActions();
        }
        this.stopAllActions();

        this.runAction(new cc.Sequence(
            new cc.DelayTime(1.15),
            new cc.CallFunc(() => this.update())
        ));
    };
}

cleverapps.styles.PlayButtonView = {
    width: 300,
    height: 100,

    position: [
        { x: { align: "center" }, y: { align: "bottom", dy: 150 } },
        { x: { align: "center" }, y: { align: "bottom", dy: 150 } },
        { x: { align: "center" }, y: { align: "bottom", dy: 150 } }
    ],

    button: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
